import { Text } from '@distribusion/portal-lib/components';
import classNames from 'classnames';
import {
  DISTRIBUSION_DEFAULT_LOGO,
  DISTRIBUSION_SMALL_LOGO,
  DISTRIBUSION_TITLE,
} from 'constants/common';
import { useTranslation } from 'lib/translation';

import './side-nav-footer.less';

interface SideNavFooterProps {
  collapsed?: boolean;
}

export const SideNavFooter = ({ collapsed }: SideNavFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames('side-nav-footer', { 'side-nav-footer--collapsed': collapsed })}>
      {!collapsed && <Text>{t('layout.powered_by')}</Text>}
      <img
        src={!collapsed ? DISTRIBUSION_DEFAULT_LOGO : DISTRIBUSION_SMALL_LOGO}
        title={DISTRIBUSION_TITLE}
        alt={DISTRIBUSION_TITLE}
      />
    </div>
  );
};
